import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessUnitLookupComponent } from './business-unit-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [BusinessUnitLookupComponent],
  exports: [BusinessUnitLookupComponent],
  providers: []
})
export class BusinessUnitLookupModule { }
